import React from 'react';
import { Button, Spinner, Alert } from 'reactstrap';
import { FiBell } from 'react-icons/fi';
import './styles.css';
import styles from './Alerts.module.scss';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import { Dropdown, borderedSelectStyles } from '@/components/Dropdown';
import { alertsTableConfig } from './Alerts.config';
import { Table as AntdTable } from 'antd';
import { EmptyState } from '@/components/EmptyState';

// Pure presentational — no Redux/react-query/service calls. Rendered by both
// Alerts.component.jsx (real, Firestore-backed) and Alerts.demo.component.jsx
// (static fixture-backed); a future redesign only ever needs to touch this
// file plus whichever container's props it changes.
export const AlertsView = ({
  teamOptions,
  selectedTeam,
  onTeamChange,
  employeeOptions,
  selectedEmployee,
  onEmployeeChange,
  employeeSelectLabel = 'Select Employee',
  membersError,
  membersErrorMessage,
  onRetryMembers,
  error,
  onRetryError,
  loading,
  filteredAlerts,
  groupedAlerts,
}) => {
  return (
    <div className={styles.alertsPage}>
      <div className={styles.alertsPageContainer}>
        <Text
          variant={textVariantsEnum.Header}
          fontWeight={fontWeightEnum.Normal}
        >
          <FiBell className="mr-2" />
          Productivity Alert
        </Text>
        <div className={styles.filtersContainer}>
          <div className={styles.dropdown}>
            <Dropdown
              label="Department"
              selectStyles={borderedSelectStyles}
              options={teamOptions}
              value={selectedTeam}
              onChange={onTeamChange}
            />
          </div>
          <div className={styles.dropdown}>
            <Dropdown
              label={employeeSelectLabel}
              selectStyles={borderedSelectStyles}
              options={employeeOptions}
              value={selectedEmployee}
              onChange={onEmployeeChange}
            />
            {membersError && selectedTeam && (
              <div className="mb-1 text-danger small">
                Failed to load members. {membersErrorMessage || ''}{' '}
                {onRetryMembers && (
                  <Button
                    color="link"
                    size="sm"
                    className="p-0"
                    onClick={onRetryMembers}
                  >
                    Retry
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
        {error && (
          <Alert color="danger" className="mt-3 w-100">
            <strong>Error:</strong> {error}
            {onRetryError && (
              <Button
                color="danger"
                size="sm"
                className="ml-2"
                onClick={onRetryError}
              >
                Retry
              </Button>
            )}
          </Alert>
        )}
        <div className={styles.alertsTableContainer}>
          {loading && (
            <div className="text-center py-4">
              <Spinner color="primary" />
              <p className="mt-2">Loading alerts...</p>
            </div>
          )}
          {!loading && filteredAlerts.length === 0 && (
            <EmptyState
              illustration
              title="No Alerts Found"
              description={
                selectedTeam || selectedEmployee
                  ? 'No alerts match the selected filters.'
                  : 'You have no alerts at this time.'
              }
            />
          )}
          {!loading && filteredAlerts.length > 0 && (
            <AntdTable
              rootClassName={styles.alertsAntdTable}
              dataSource={Object.values(groupedAlerts)}
              pagination={false}
              columns={alertsTableConfig()}
            />
          )}
        </div>
      </div>
    </div>
  );
};
